module.exports = __webpack_public_path__ + "img/karachun.23313d6b.jpg";